import MapRegionView from './MapRegionView';

export default MapRegionView;
